import * as actionTypes from "../../Actions/PlanView/ActionTypes";
import * as actionReducer from "./ActionReducer";
import * as pinActionReducer from "./PinActionReducer";
import * as polygonActionReducer from "./PolygonActionReducer";
import * as liveTrackActionReducer from "./LiveTrackActionReducer";

const initialState = {
  map: null,
  Drivers: [], // liveTrack Drivers List
  planId: null,
  wareHouse: null,
  SingleDriver: null, // liveTrack Driver Info
  ModifyActions: null, // actions can used in plan View
  screenFreeze: false,
  cantDoAnything: false, // true -> nothing to do (buttons)
  cantDoEditAfterGetExternal: false, // user config: lock pins sent by get external
  PlanHasLastPin: false, // to show confirmation last pins button
  planProvinceCode: null,
  planViewMapDrawerTab: 3, // planViewMapDrawerTab: 1 => RemainPin, 2 => Pin, 3 => Polygon, 4 => NotMets, 5 => DeletedPins,
  liveTrackMapDrawerTab: 1, // liveTrackMapDrawerTab: 1 => Drivers, 2 => Single Driver
  mapViewState: "PLAN_VIEW", // PLAN_VIEW  LIVE_TRACK
  socketIsListeningToMap: false,
  socketLiveTackIsListeningToMap: false,

  findMissionCard: {
    // liveTrack find mission card
    State: null,
    MissionId: null,
  },

  mainPlanData: {
    // all polygons, remains, etc in natural (without vehicle filter - for "planReset")
    notMets: [],
    polygons: [],
    remainPins: [],
    deletedPins: [],
  },

  goToDriverMissionInfo: {
    driverId: null,
    clusterId: null,
  },

  LiveTrack: {
    flyToMission: [],
    SearchedDriver: null,
    NextPrevMissionInfo: null, // mission
    DriversMissionCounter: {},
    justShowSpecificDrivers: [], // driver Id(s)
    showDirverMissionInfo: false,
    showDirverMissionConfirmation: false, // driver confirmation request dialog
  },

  ContextMenu: {
    // for mouse right Click Box
    pos: {
      x: 0,
      y: 0,
    },
    show: false,
    boxType: "map", // boxType: map - pin - polygon
    onPin: null, // right click on Pin
    onPolygon: null, // right click on polyogn
  },

  ChangedPolygons: {
    CP: [], // Create Polygon - changed polygons
    MCP: [], // Merge - changed polygons
    ACP: [], // Adjust pin - changed polygons
    DCP: [], // Delete pin - changed polygons
    RMCP: [], // ReMain pin - changed polygons
    RSCP: [], // ReStore pin - changed polygons
    NMCP: [], // Not Met pin - changed polygons
    RACP: [], // ReAssign pin - changed polygons
    TotalChangedPolygons: [], // uid of polygon has been changed for plan Reset
    LogHistory: [],
  },

  MenuItems: {
    // right menu items button : false -> off, true -> on
    pin: false,
    info: false,
    merge: false,
    resequence: 1, // 1 => noReseq,  2 => Reseqing,  3 => mustReseq
    polygon: true,
    drawer: false,
    polygonPins: 0, // 0 => disabled,  1 => active and hide, 2 => active and show
    lastPin: false,
    vehicle: "car",
    drawPoly: false,
    createPoly: false,
    changeReseq: false, // live track - change sequence of mission
    multiSelect: false,
    multiPolygonPins: [], // list of polygon - show pins
    requestVehicle: false,
    showDriverRoute: false, // live track actual route
    showActualDeliveryMission: false, // live track actual delivery mission
    showAllRoute:false,
  },

  MapItems: {
    selectedPin: false,
    selectedPolygon: false,
  },

  PolygonSetting: {
    flyToCoords: [],
    ShowRoute: false,
    MergePolygons: [], // uid of polygons must merge
    DrawPolygonCoords: [], // list of lists
    showListOfPolygons: true, // showListOfPolygons: true => show list, false => show selectedPolygon
    RequestVehiclePolygons: [],
    showDeclusterDialog: false,
    SelectDismissPolygon: false,
    hideOtherPolygonsExcept: [], // polygon uid
    isShowOnlyNoDriverPolygons: false, // sticky filter: only show polygons without driver
    showListOfHubsToAssign: false,
    showListOfDriversToAssign: false,
    showDriverInDriverAssignList: false,
  },

  PinSetting: {
    flyToPin: [],
    MultiSelect: [],
    SetRemainPin: [], // selected coods on map in Assign remain pin
    NotMetsCreatePolygon: [],
    RemainsCreatePolygon: [],
    ReAssign: false,
    AssignRemainPin: [], // set Remain pin here - remain mode
    AssignNotMetPin: false, // set notmet pin here or false - notmet mode
    deletedPinNoPolygon: null, // if pin deleted but polygon is removed - store pin
    showListOfPolygonPins: false, // showListOfPolygonPins => true => show Pins list, false => show selectedPin
  },

  missionInfoCount: {},

  FilteredPolygons: {
    polygons: null, // all polygons with children (with vehicle filter)
    polygonsWOC: null, // all polygons without children (with vehicle filter)
  },

  PlanInfo: {
    error: null,
    request: null,
    response: null, // all polygons in natural (without vehicle filter) (**!** NEVER CHANGE THIS ONE **!**)
  },

  PreviewInfo: {
    error: null,
    request: null,
    response: null,
  },

  DispatchDriver: {
    error: null,
    request: null,
    response: null,
  },

  PlanStatus: {
    error: null,
    request: null,
    response: null,
  },

  ActualRoute: {
    error: null,
    request: null,
    response: null,
    nullMissionIdRoute: null,
  },

  PlanReset: {
    error: null,
    request: null,
    response: null,
  },

  removeDriverPolygon: {
    error: null,
    request: null,
    response: null,
  },

  removeDistributorPolygon: {
    error: null,
    request: null,
    response: null,
  },

  chatMessages: {
    error: null,
    request: null,
    response: null,
  },

  driverActivation: {
    error: null,
    request: null,
    response: null,
  },

  RemainPinCoord: {
    error: null,
    request: null,
    response: null,
  },

  LastPin: {
    error: null,
    request: null,
    response: null,
  },

  ConfirmLastPin: {
    error: null,
    request: null,
    response: null,
  },

  liveTrackDrivers: {
    error: null,
    request: null,
    response: null,
  },

  DriverMissionInfo: {
    error: null,
    request: null,
    response: null,
  },

  ChangeStatus: {
    error: null,
    request: null,
    response: null,
  },

  GetMissionInfo: {
    error: null,
    request: null,
    response: null,
  },

  NextPrevPlan: {
    error: null,
    request: null,
    response: null,
    state: null,
  },

  MissionStatusExcel: {
    error: null,
    request: null,
    response: null,
    state: null,
  },

  searchLiveTrack: {
    error: null,
    request: null,
    response: null,
  },

  autoAssign: {
    error: null,
    request: null,
    response: null,
  },

  allMissionPOD: {
    error: null,
    request: null,
    response: null,
  },

  lightPlanInfo: {
    error: null,
    request: null,
    response: null,
  },

  cityLayers: {
    error: null,
    request: null,
    response: null,
  },

  actualDelivery: {
    error: null,
    request: null,
    response: null,
  },

  autoAssignMicrohubs: {
    error: null,
    request: null,
    response: null,
  },

  AddNewLastPin: {
    error: null,
    request: null,
    response: null,
  },

  EditVehicleName: {
    error: null,
    request: null,
    response: null,
  },

  liveTrackInfo: {
    error: null,
    request: null,
    response: null,
  },

  savePlanPreview: {
    error: null,
    request: null,
    response: null,
  },

  SingleMissionConfirmation: {
    error: null,
    request: null,
    response: null,
  },

  MissionConfirmation: {
    error: null,
    response: [],
    request: null,
  },

  PostMissionConfirmation: {
    error: null,
    request: null,
    response: null,
  },

  ChangeMissionOrder: {
    error: null,
    request: null,
    response: null,
  },

  RequestVehicle: {
    error: null,
    request: null,
    response: null,
  },


  deactiveDrivers: {
    error: null,
    request: null,
    response: null,
  },

  dispatchToAllAssignedDrivers: {
    error: null,
    request: null,
    response: null,
  },

};

const PlanViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_MAP:
      return actionReducer.setMap(state, action);

    case actionTypes.TOGGLE_SOCKET_LISTENING:
      return actionReducer.toggleSocketIsListeningToMap(state, action);

    case actionTypes.TOGGLE_SOCKET_LIVETACK_LISTENING:
      return liveTrackActionReducer.toggleSocketLiveTackIsListeningToMap(
        state,
        action
      );

    case actionTypes.FIND_MISSION_CARD:
      return liveTrackActionReducer.findMissionCard(state, action);

    case actionTypes.NEXT_PREV_MISSION:
      return liveTrackActionReducer.nextPrevMission(state, action);

    case actionTypes.CHANGE_MAP_VIEW_STATE:
      return actionReducer.mapViewState(state, action);

    case actionTypes.ADD_PLAN_ID:
      return actionReducer.addPlanId(state, action);

    case actionTypes.TOGGLE_MENU_ITEM:
      return actionReducer.toggleMenuItem(state, action);

    case actionTypes.CHANGE_CONTEXT_MENU:
      return actionReducer.changeContextMenu(state, action);

    case actionTypes.SCREEN_MUST_FREEZE:
      return actionReducer.screenMustFreeze(state, action);

    case actionTypes.CHANGE_DRIVER_VEHICLE:
      return liveTrackActionReducer.DriverVehicleIsUpdated(state, action);

    case actionTypes.UPDATE_POLYGON_SETTING:
      return polygonActionReducer.updatePolygonSetting(state, action);

    case actionTypes.SET_SHOW_ONLY_NO_DRIVER_POLYGONS:
      return polygonActionReducer.setShowOnlyNoDriverPolygons(state, action);

    case actionTypes.UPDATE_PIN_SETTING:
      return pinActionReducer.updatePinSetting(state, action);

    case actionTypes.UPDATE_SINGLE_DRIVER_INFO:
      return liveTrackActionReducer.updateSingleDriverInfo(state, action);

    case actionTypes.CHANGE_POLYGONS:
      return polygonActionReducer.changePolygon(state, action, initialState);

    case actionTypes.UPDATE_POLYGONS_LIST:
      return polygonActionReducer.updatePolygonsList(state, action);

    case actionTypes.UPDATE_LIVETRACK_DRIVERS:
      return liveTrackActionReducer.updateLiveTrackDrivers(state, action);

    case actionTypes.GO_TO_DRIVER_MISSION_INFO:
      return liveTrackActionReducer.goToDriverMissionInfo(state, action);

    case actionTypes.UPDATE_LIVETRACK_ITEMS:
      return liveTrackActionReducer.updateLiveTrackItems(state, action);

    case actionTypes.MAP_DRAWER_TAB:
      return actionReducer.changeMapDrawerTab(state, action);

    case actionTypes.LOG_HISTORY:
      return actionReducer.logHistory(state, action);

    case actionTypes.CHANGE_LIVETRACK_MAP_TAB:
      return liveTrackActionReducer.changeLiveTrackMapDrawerTab(state, action);

    case actionTypes.STOP_WORKING_BUTTONS:
      return actionReducer.stopWorkingButtons(state, action);

    case actionTypes.SET_CANT_DO_EDIT_AFTER_GET_EXTERNAL:
      return actionReducer.setCantDoEditAfterGetExternal(state, action);

    case actionTypes.SELECT_POLYGON:
      return polygonActionReducer.selectPolygon(state, action);

    case actionTypes.SELECT_PIN:
      return pinActionReducer.selectPin(state, action, initialState);

    case actionTypes.CHANGE_DATA_FOR_PLAN_RESET:
      return actionReducer.changeDataForPlanReset(state, action);

    case actionTypes.CLEAR_STATE:
      return actionReducer.clearState(state, action, initialState);

    case actionTypes.GET_PLAN_INFO:
      return actionReducer.getPlanInfo(state, action);
    case actionTypes.GET_PLAN_INFO_SUCCESS:
      return actionReducer.getPlanInfoSuccess(state, action);
    case actionTypes.GET_PLAN_INFO_FAIL:
      return actionReducer.getPlanInfoFail(state, action);

    case actionTypes.GET_PLAN_PREVIEW_INFO:
      return actionReducer.getPlanPreviewInfo(state, action);
    case actionTypes.GET_PLAN_PREVIEW_INFO_SUCCESS:
      return actionReducer.getPlanPreviewInfoSuccess(state, action);
    case actionTypes.GET_PLAN_PREVIEW_INFO_FAIL:
      return actionReducer.getPlanPreviewInfoFail(state, action);

    case actionTypes.GET_PLAN_LIGHT_INFO:
      return actionReducer.getLightPlanInfo(state, action);
    case actionTypes.GET_PLAN_LIGHT_INFO_SUCCESS:
      return actionReducer.getLightPlanInfoSuccess(state, action);
    case actionTypes.GET_PLAN_LIGHT_INFO_FAIL:
      return actionReducer.getLightPlanInfoFail(state, action);

    case actionTypes.GET_PLAN_STATUS:
      return actionReducer.getPlanStatus(state, action);
    case actionTypes.GET_PLAN_STATUS_SUCCESS:
      return actionReducer.getPlanStatusSuccess(state, action);
    case actionTypes.GET_PLAN_STATUS_FAIL:
      return actionReducer.getPlanStatusFail(state, action);

    case actionTypes.GET_NEXT_PREV_PLAN:
      return actionReducer.getNextPrevPlan(state, action);
    case actionTypes.GET_NEXT_PREV_PLAN_SUCCESS:
      return actionReducer.getNextPrevPlanSuccess(state, action);
    case actionTypes.GET_NEXT_PREV_PLAN_FAIL:
      return actionReducer.getNextPrevPlanFail(state, action);

    case actionTypes.GET_MISSION_STATUS_EXCEL:
      return actionReducer.getMissionStatusExcel(state, action);
    case actionTypes.GET_MISSION_STATUS_EXCEL_SUCCESS:
      return actionReducer.getMissionStatusExcelSuccess(state, action);
    case actionTypes.GET_MISSION_STATUS_EXCEL_FAIL:
      return actionReducer.getMissionStatusExcelFail(state, action);

    case actionTypes.GET_REMAIN_PIN_COORDS:
      return pinActionReducer.getRemainCoord(state, action);
    case actionTypes.GET_REMAIN_PIN_COORDS_SUCCESS:
      return pinActionReducer.getRemainCoordSuccess(state, action);
    case actionTypes.GET_REMAIN_PIN_COORDS_FAIL:
      return pinActionReducer.getRemainCoordFail(state, action);

    case actionTypes.SAVE_PLAN_PREVIEW_INFO:
      return actionReducer.savePlanPreview(state, action);
    case actionTypes.SAVE_PLAN_PREVIEW_INFO_SUCCESS:
      return actionReducer.savePlanPreviewSuccess(state, action);
    case actionTypes.SAVE_PLAN_PREVIEW_INFO_FAIL:
      return actionReducer.savePlanPreviewFail(state, action);

    case actionTypes.PLAN_RESET:
      return actionReducer.planReset(state, action);
    case actionTypes.PLAN_RESET_SUCCESS:
      return actionReducer.planResetSuccess(state, action);
    case actionTypes.PLAN_RESET_FAIL:
      return actionReducer.planResetFail(state, action);

    case actionTypes.REMOVE_DRIVER_FROM_POLYGON:
      return actionReducer.removeDriverFromPolygon(state, action);
    case actionTypes.REMOVE_DRIVER_FROM_POLYGON_SUCCESS:
      return actionReducer.removeDriverFromPolygonSuccess(state, action);
    case actionTypes.REMOVE_DRIVER_FROM_POLYGON_FAIL:
      return actionReducer.removeDriverFromPolygonFail(state, action);

    case actionTypes.REMOVE_DISTRIBUTOR_FROM_POLYGON:
      return actionReducer.removeDistributorFromPolygon(state, action);
    case actionTypes.REMOVE_DISTRIBUTOR_FROM_POLYGON_SUCCESS:
      return actionReducer.removeDistributorFromPolygonSuccess(state, action);
    case actionTypes.REMOVE_DISTRIBUTOR_FROM_POLYGON_FAIL:
      return actionReducer.removeDistributorFromPolygonFail(state, action);

    case actionTypes.DRIVER_ACTIVATION:
      return actionReducer.driverActivation(state, action);
    case actionTypes.DRIVER_ACTIVATION_SUCCESS:
      return actionReducer.driverActivationSuccess(state, action);
    case actionTypes.DRIVER_ACTIVATION_FAIL:
      return actionReducer.driverActivationFail(state, action);

    case actionTypes.DISPATCH_TO_DRIVER:
      return actionReducer.DispatchToDriver(state, action);
    case actionTypes.DISPATCH_TO_DRIVER_SUCCESS:
      return actionReducer.DispatchToDriverSuccess(state, action);
    case actionTypes.DISPATCH_TO_DRIVER_FAIL:
      return actionReducer.DispatchToDriverFail(state, action);

    case actionTypes.UPLOAD_LAST_PIN:
      return pinActionReducer.uploadLastPin(state, action);
    case actionTypes.UPLOAD_LAST_PIN_SUCCESS:
      return pinActionReducer.uploadLastPinSuccess(state, action);
    case actionTypes.UPLOAD_LAST_PIN_FAIL:
      return pinActionReducer.uploadLastPinFail(state, action);

    case actionTypes.CONFIRM_LAST_PIN:
      return pinActionReducer.confirmLastPin(state, action);
    case actionTypes.CONFIRM_LAST_PIN_SUCCESS:
      return pinActionReducer.confirmLastPinSuccess(state, action);
    case actionTypes.CONFIRM_LAST_PIN_FAIL:
      return pinActionReducer.confirmLastPinFail(state, action);

    case actionTypes.GET_LIVETRACK_DRIVERS:
      return liveTrackActionReducer.getLiveTrackDrivers(state, action);
    case actionTypes.GET_LIVETRACK_DRIVERS_SUCCESS:
      return liveTrackActionReducer.getLiveTrackDriversSuccess(state, action);
    case actionTypes.GET_LIVETRACK_DRIVERS_FAIL:
      return liveTrackActionReducer.getLiveTrackDriversFail(state, action);

    case actionTypes.GET_MISSION_INFO:
      return liveTrackActionReducer.getMissionInfo(state, action);
    case actionTypes.GET_MISSION_INFO_SUCCESS:
      return liveTrackActionReducer.getMissionInfoSuccess(state, action);
    case actionTypes.GET_MISSION_INFO_FAIL:
      return liveTrackActionReducer.getMissionInfoFail(state, action);

    case actionTypes.GET_DRIVER_MISSION_INFO:
      return liveTrackActionReducer.getDriverMissionInfo(state, action);
    case actionTypes.GET_DRIVER_MISSION_INFO_SUCCESS:
      return liveTrackActionReducer.getDriverMissionInfoSuccess(state, action);
    case actionTypes.GET_DRIVER_MISSION_INFO_FAIL:
      return liveTrackActionReducer.getDriverMissionInfoFail(state, action);

    case actionTypes.GET_DRIVER_MISSION_INFO_COUNT:
      return liveTrackActionReducer.getDriverMissionInfoCount(state, action);
    case actionTypes.GET_DRIVER_MISSION_INFO_COUNT_SUCCESS:
      return liveTrackActionReducer.getDriverMissionInfoCountSuccess(
        state,
        action
      );
    case actionTypes.GET_DRIVER_MISSION_INFO_COUNT_FAIL:
      return liveTrackActionReducer.getDriverMissionInfoCountFail(
        state,
        action
      );

    case actionTypes.CHANGE_MISSION_STATUS:
      return liveTrackActionReducer.changeMissionStatus(state, action);
    case actionTypes.CHANGE_MISSION_STATUS_SUCCESS:
      return liveTrackActionReducer.changeMissionStatusSuccess(state, action);
    case actionTypes.CHANGE_MISSION_STATUS_FAIL:
      return liveTrackActionReducer.changeMissionStatusFail(state, action);

    case actionTypes.SEARCH_IN_LIVETRACK:
      return liveTrackActionReducer.searchInLiveTrack(state, action);
    case actionTypes.SEARCH_IN_LIVETRACK_SUCCESS:
      return liveTrackActionReducer.searchInLiveTrackSuccess(state, action);
    case actionTypes.SEARCH_IN_LIVETRACK_FAIL:
      return liveTrackActionReducer.searchInLiveTrackFail(state, action);

    case actionTypes.GET_ACTUAL_DELIVERY_MISSION:
      return liveTrackActionReducer.getActualDeliveryMission(state, action);
    case actionTypes.GET_ACTUAL_DELIVERY_MISSION_SUCCESS:
      return liveTrackActionReducer.getActualDeliveryMissionSuccess(
        state,
        action
      );
    case actionTypes.GET_ACTUAL_DELIVERY_MISSION_FAIL:
      return liveTrackActionReducer.getActualDeliveryMissionFail(state, action);

    case actionTypes.GET_ACTUAL_ROUTE:
      return liveTrackActionReducer.getActualRoute(state, action);
    case actionTypes.GET_ACTUAL_ROUTE_SUCCESS:
      return liveTrackActionReducer.getActualRouteSuccess(state, action);
    case actionTypes.GET_ACTUAL_ROUTE_FAIL:
      return liveTrackActionReducer.getActualRouteFail(state, action);

    case actionTypes.AUTO_DRIVER_ASSIGN:
      return actionReducer.autoAssign(state, action);
    case actionTypes.AUTO_DRIVER_ASSIGN_SUCCESS:
      return actionReducer.autoAssignSuccess(state, action);
    case actionTypes.AUTO_DRIVER_ASSIGN_FAIL:
      return actionReducer.autoAssignFail(state, action);

    case actionTypes.GET_CHAT_MESSAGES:
      return actionReducer.getChatMessages(state, action);
    case actionTypes.GET_CHAT_MESSAGES_SUCCESS:
      return actionReducer.getChatMessagesSuccess(state, action);
    case actionTypes.GET_CHAT_MESSAGES_FAIL:
      return actionReducer.getChatMessagesFail(state, action);

    case actionTypes.REQUEST_VEHICLE:
      return actionReducer.requestPolygon(state, action);
    case actionTypes.REQUEST_VEHICLE_SUCCESS:
      return actionReducer.requestPolygonSuccess(state, action);
    case actionTypes.REQUEST_VEHICLE_FAIL:
      return actionReducer.requestPolygonFail(state, action);

    case actionTypes.GET_ALL_MISSION_POD:
      return liveTrackActionReducer.getAllMissionPod(state, action);
    case actionTypes.GET_ALL_MISSION_POD_SUCCESS:
      return liveTrackActionReducer.getAllMissionPodSuccess(state, action);
    case actionTypes.GET_ALL_MISSION_POD_FAIL:
      return liveTrackActionReducer.getAllMissionPodFail(state, action);

    case actionTypes.GET_CITY_LAYERS:
      return actionReducer.getCityLayers(state, action);
    case actionTypes.GET_CITY_LAYERS_SUCCESS:
      return actionReducer.getCityLayersSuccess(state, action);
    case actionTypes.GET_CITY_LAYERS_FAIL:
      return actionReducer.getCityLayersFail(state, action);

    case actionTypes.AUTO_ASSIGN_MICROHUBS:
      return actionReducer.autoAssignMicrohubs(state, action);
    case actionTypes.AUTO_ASSIGN_MICROHUBS_SUCCESS:
      return actionReducer.autoAssignMicrohubsSuccess(state, action);
    case actionTypes.AUTO_ASSIGN_MICROHUBS_FAIL:
      return actionReducer.autoAssignMicrohubsFail(state, action);

    case actionTypes.ADD_NEW_PIN_TO_PLAN:
      return actionReducer.addNewPinToPlan(state, action);
    case actionTypes.ADD_NEW_PIN_TO_PLAN_SUCCESS:
      return actionReducer.addNewPinToPlanSuccess(state, action);
    case actionTypes.ADD_NEW_PIN_TO_PLAN_FAIL:
      return actionReducer.addNewPinToPlanFail(state, action);

    case actionTypes.EDIT_VEHICLE_NAME:
      return actionReducer.EditVehicleName(state, action);
    case actionTypes.EDIT_VEHICLE_NAME_SUCCESS:
      return actionReducer.EditVehicleNameSuccess(state, action);
    case actionTypes.EDIT_VEHICLE_NAME_FAIL:
      return actionReducer.EditVehicleNameFail(state, action);

    case actionTypes.GET_LIVETRACK_INFO:
      return liveTrackActionReducer.getLivetrackInfo(state, action);
    case actionTypes.GET_LIVETRACK_INFO_SUCCESS:
      return liveTrackActionReducer.getLivetrackInfoSuccess(state, action);
    case actionTypes.GET_LIVETRACK_INFO_FAIL:
      return liveTrackActionReducer.getLivetrackInfoFail(state, action);

    case actionTypes.GET_MISSION_CONFIRMATION:
      return liveTrackActionReducer.getMissionConfirmation(state, action);
    case actionTypes.GET_MISSION_CONFIRMATION_SUCCESS:
      return liveTrackActionReducer.getMissionConfirmationSuccess(
        state,
        action
      );
    case actionTypes.GET_MISSION_CONFIRMATION_FAIL:
      return liveTrackActionReducer.getMissionConfirmationFail(state, action);

    case actionTypes.SET_MISSION_CONFIRMATION:
      return liveTrackActionReducer.setMissionConfirmation(state, action);
    case actionTypes.SET_MISSION_CONFIRMATION_SUCCESS:
      return liveTrackActionReducer.setMissionConfirmationSuccess(
        state,
        action
      );
    case actionTypes.SET_MISSION_CONFIRMATION_FAIL:
      return liveTrackActionReducer.setMissionConfirmationFail(state, action);

    case actionTypes.CHANGE_MISSIONS_ORDER:
      return liveTrackActionReducer.changeMissionsOrder(state, action);
    case actionTypes.CHANGE_MISSIONS_ORDER_SUCCESS:
      return liveTrackActionReducer.changeMissionsOrderSuccess(state, action);
    case actionTypes.CHANGE_MISSIONS_ORDER_FAIL:
      return liveTrackActionReducer.changeMissionsOrderFail(state, action);

    case actionTypes.DEACTIVE_DRIVERS:
      return liveTrackActionReducer.deactiveDrivers(state, action);
    case actionTypes.DEACTIVE_DRIVERS_SUCCESS:
      return liveTrackActionReducer.deactiveDriversSuccess(state, action);
    case actionTypes.DEACTIVE_DRIVERS_FAIL:
      return liveTrackActionReducer.deactiveDriversFail(state, action);

    case actionTypes.DISPATCH_TO_ALL_ASSIGNED_DRIVERS:
      return actionReducer.dispatchToAllAssignedDrivers(state, action);
    case actionTypes.DISPATCH_TO_ALL_ASSIGNED_DRIVERS_SUCCESS:
      return actionReducer.dispatchToAllAssignedDriversSuccess(state, action);
    case actionTypes.DISPATCH_TO_ALL_ASSIGNED_DRIVERS_FAIL:
      return actionReducer.dispatchToAllAssignedDriversFail(state, action);

    default:
      return state;
  }
};

export { PlanViewReducer };
